'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.endOperation = exports.startOperation = exports.redoAction = exports.undoAction = undefined;

var _analytics = require('../../analytics');

var _undoRedoSelector = require('./undoRedoSelector');

var _undoRedoConstants = require('./undoRedoConstants');

var _undoRedoTransactionManager = require('./undoRedoTransactionManager');

// Constants
var NO_ACTIONS = [];

// Selectors


var getTransactionActions = function getTransactionActions(stackName, getState) {
    var state = getState();
    var stack = state.getIn(['undoRedo', stackName]);

    if (stack.size <= 0) return NO_ACTIONS;

    var transactionId = stack.peek();
    return state.getIn(['undoRedo', 'transactions', transactionId]) || NO_ACTIONS;
};

var undoAction = exports.undoAction = function undoAction() {
    return function (dispatch, getState) {
        var undoActions = getTransactionActions('undoStack', getState);
        undoActions.reverse().forEach(function (action) {
            return action.undo && dispatch(action.undo);
        });

        if (undoActions.size) {
            (0, _analytics.analyticsEvent)('used-undo');
        }
    };
};

var redoAction = exports.redoAction = function redoAction() {
    return function (dispatch, getState) {
        var redoActions = getTransactionActions('redoStack', getState);
        redoActions.forEach(function (action) {
            return action.redo && dispatch(action.redo);
        });
    };
};

// Operation Actions
var startOperation = exports.startOperation = function startOperation(name) {
    return function (dispatch, getState) {
        var state = getState();
        var operation = (0, _undoRedoSelector.getCurrentOperation)(state);

        // Don't dispatch a new operation if we're already in an operation.
        // This doesn't support parallel operations. If it's required this should be revisited
        if (operation) return;

        return dispatch({
            type: _undoRedoConstants.START_OPERATION,
            name: name,
            transactionId: (0, _undoRedoTransactionManager.getNewTransactionId)()
        });
    };
};

var endOperation = exports.endOperation = function endOperation(name) {
    return function (dispatch, getState) {
        var state = getState();
        var operation = (0, _undoRedoSelector.getCurrentOperation)(state);

        if (!operation) return;

        var transactionId = (0, _undoRedoSelector.getMostRecentTransactionId)(state);
        dispatch({
            type: _undoRedoConstants.END_OPERATION,
            name: name,
            transactionId: transactionId
        });
        return transactionId;
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/undoRedo/undoRedoActions.js
// module id = 316
// module chunks = 0